<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("myFestivalMovies", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("myFestivalMovies", 2) }}
          {{ $tc("incinematic") }}
        </div>
      </div>
      <div>
        <b-button
          v-if="isEditable && checkEditOrder"
          variant="default"
          class="btn-blue"
          @click="() => updateListOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else-if="checkEditOrder"
          variant="default"
          class="btn-blue"
          @click="() => isOrderEditable()"
          >{{ $t("Edit order") }}</b-button
        >
        <router-link
          variant="default"
          class="btn-blue"
          to="add-myfestival-movie"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <div>
          <b-form-input
            v-debounce:300="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          />
        </div>
      </div>
      <div class="d-flex align-items-center">
        <b-dropdown
          :text="selected_category"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(cat, catIndex) in superCategories"
            :key="catIndex"
            v-on:click="onChangeCategory(cat)"
            >{{ cat.category_name }}</b-dropdown-item
          >
        </b-dropdown>
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              filter_is_active = filterIsActive;
              isEditable = false;
              columnName = '';
              orderBy = '';
              currentPage = 1;
              getCategoryLinkMovieList();
            }
          "
        />
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $tc("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th class="w-10" v-if="isEditable">{{ $t("serial_order") }}></th>
          <th>
            <img
              v-if="this.columnName != 'category_link_name' && !isEditable"
              @click="onSortValue('category_link_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending && !isEditable"
              @click="onSortValue('category_link_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="!isEditable"
              @click="onSortValue('category_link_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("event") }} {{ $tc("name") }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'category_name' && !isEditable"
              @click="onSortValue('category_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending && !isEditable"
              @click="onSortValue('category_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="!isEditable"
              @click="onSortValue('category_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("category_type") }}
          </th>
        </tr>
      </thead>
      <template v-if="Categories && Categories.length > 0">
        <draggable
          :list="Categories"
          tag="tbody"
          @end="endSort($event)"
          :move="draggableElements"
        >
          <tr v-for="(item, key) in Categories" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    item.cat_link_is_active == 'Y' ? 'active' : 'inactive'
                  "
                />
                <i
                  v-if="$can('update', 'My Festival Movie')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  @click="goToRoute('/mycinemas/edit-myfestival-movie', item)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td class="w-10" v-if="isEditable">{{ key + 1 }}</td>
            <td>{{ $tc(item.category_link_name, 1) }}</td>
            <td>{{ item.category_name }}</td>
            <!-- <td>
            <div class="d-flex align-items-center justify-content-end"> -->
            <!-- <label class="ios-switch">
                <input
                  :checked="item.cat_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
            <!-- <StatusDot
                :status="item.cat_link_is_active == 'Y' ? 'active' : 'inactive'"
              />

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/mycinemas/edit-myfestival-movie', item)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          </tr>
        </draggable>
      </template>
      <tbody v-if="Categories.length == 0">
        <tr>
          <td colspan="2">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import MasterService from "@/services/MasterService";
import MyCinemaService from "@/services/MyCinemaService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import draggable from "vuedraggable";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
    draggable,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      Cinemas: [],
      selectedCinema: undefined,
      cinema_id: null,

      gridView: false,
      listView: true,

      Categories: [],
      customErrors: {
        message: "",
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      selected_category: "All",
      category_id: null,
      superCategories: [],
      searchValue: "",
      filter_is_active: "Y",

      isEditable: false,
    };
  },
  computed: {
    checkEditOrder() {
      if (this.category_id && this.filter_is_active == "Y") {
        return true;
      } else {
        return false;
      }
    },
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },
  beforeMount() {
    this.getviewingnumber();
    this.getCategoryLinkMovieList();
    this.getSuperCategories();
  },
  methods: {
    endSort(event) {
      this.Categories.map((x, index) => {
        if (this.currentPage != 1) {
          x.category_order =
            this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.category_order = index + 1;
        }
      });
      console.log("this.sorted banner", this.Categories);
      console.log("this.event", event);
    },
    draggableElements: function () {
      return this.isEditable;
    },
    isOrderEditable: function () {
      this.isEditable = true;
      this.columnName = "";
      this.orderBy = "";
      if (this.isEditable) {
        this.filter_is_active = "Y";
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCategoryLinkMovieList();
    },
    updateListOrder: function () {
      this.isEditable = false;
      let payload = {
        Categories: this.Categories,
      };
      MasterService.UpdateMovieCategoryOrder(payload)
        .then((data) => {
          console.log("data", data);
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onSearch(event) {
      this.searchValue = event;
      this.currentPage = 1;
      this.getCategoryLinkMovieList();
    },
    onChangeCategory(category) {
      this.currentPage = 1;
      this.isEditable = false;
      (this.selected_category = category.category_name),
        (this.category_id = category.category_id),
        this.getCategoryLinkMovieList();
    },
    getSuperCategories: function () {
      this.superCategories = [];
      let body = {
        tableName: "gogo_category",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.superCategories = data.Records.filter(
              (x) => x.category_id > 2
            );
            this.superCategories.unshift({
              category_name: "All",
              category_id: null,
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getCategoryLinkMovieList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCategoryLinkMovieList();
      } else {
        this.currentPage = event;
        this.getCategoryLinkMovieList();
      }
    },
    /* eslint-disable */
    goToRoute: function (path, item) {
      const { unique_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: unique_id,
        },
      });
    },

    getCategoryLinkMovieList: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        search: this.searchValue,
        category_id: this.category_id,
        filter_is_active: this.filter_is_active,
      };
      this.Categories = [];
      MyCinemaService.GetCategoryLinkMovies(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Categories = data.Records;
              if (this.currentPage == 1) {
                this.rows = data.Pagination.total;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style>
.w-10 {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/MyCinemas/CategoryLinkMovie/ListCategoryLinkMovie.vue